import { CompanyStructure } from "@wingspanhq/users/dist/lib/interfaces";

export const BUSINESS_COMPANY_STRUCTURE_SELECT_OPTIONS = [
  {
    label: "Sole proprietorship",
    value: CompanyStructure.SoleProprietorship
  },
  {
    label: "S-corp",
    value: CompanyStructure.CorporationS
  },
  {
    label: "C-corp",
    value: CompanyStructure.CorporationC
  },
  {
    label: "Partnership",
    value: CompanyStructure.Partnership
  },
  {
    label: "LLC (single member)",
    value: CompanyStructure.LlcSingleMember
  },
  {
    label: "LLC (Taxed as S-corp)",
    value: CompanyStructure.LLCCorporationS
  },
  {
    label: "LLC (Taxed as C-corp)",
    value: CompanyStructure.LLCCorporationC
  },
  {
    label: "LLC (Taxed as Partnership)",
    value: CompanyStructure.LLCPartnership
  }
];

export const INDIVIDUAL_COMPANY_STRUCTURE_SELECT_OPTIONS = [
  {
    label: "Sole proprietorship",
    value: CompanyStructure.SoleProprietorship
  },
  {
    label: "LLC (single member)",
    value: CompanyStructure.LlcSingleMember
  }
];
